import { useTheme } from '@mui/material/styles'
import MuiAppBar, { AppBarProps } from '@mui/material/AppBar'

const AppBar = (props: AppBarProps) => {
  const theme = useTheme()

  return (
    <MuiAppBar elevation={0} position="fixed" {...props}>
      <img
        //@ts-ignore
        src={theme.custom.logo}
        width="83"
        height="auto"
        alt="SPF Private Clients"
      />
    </MuiAppBar>
  )
}

export default AppBar
